import React from "react";
import {getAdminMessages} from "../../../services/AdminService";
import {Container} from "react-bootstrap";
import ToolkitProvider, {Search} from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";

export const AdminShowMessagesGrid = ({logs}) => {
    const {SearchBar} = Search;


    const dateFormatter = (cell) => {

        if (cell) {
            return moment(cell.toDate()).format("YYYY-MM-DD")
        } else return <span>Inget datum</span>
    }


    const columns = [
        {
            dataField: 'email',
            text: 'E-post:',
            sort: true,
            headerStyle: {textDecoration: 'underline', cursor: 'pointer'}

        },
        {
            dataField: 'firstname',
            text: 'Förnamn:',
            sort: true,
            headerStyle: {textDecoration: 'underline', cursor: 'pointer'}

        },
        {
            dataField: 'lastname',
            text: `Efternamn: `,
            sort: true,
            headerStyle: {textDecoration: 'underline', cursor: 'pointer'}

        },
        {
            dataField: 'messageSent',
            text: 'Inskickad:',
            sort: true,
            formatter: dateFormatter,
            headerStyle: {textDecoration: 'underline', cursor: 'pointer'}

        },

        {
            dataField: 'message',
            text: `Meddelande: `,
            sort: true,
            headerStyle: {textDecoration: 'underline', cursor: 'pointer'}

        },
        {
            dataField: "subject",
            text: 'Ämne',
            headerStyle: {textDecoration: 'underline', cursor: 'pointer'}

        }, {
            dataField: "userUID",
            text: 'Användare:',
            headerStyle: {textDecoration: 'underline', cursor: 'pointer'}

        }
    ];


    return (
        <Container fluid className={"leadsGrid"}>
            <ToolkitProvider

                keyField="id"
                data={logs}
                columns={columns}
                search
            >
                {props => (
                    <React.Fragment>
                        <label>
                            Meddelanden från kund
                        </label>
                        <div>


                            <SearchBar placeholder="Sök" srText={null}
                                       className="SearchBar" {...props.searchProps} />
                            <BootstrapTable wrapperClasses="table-responsive" {...props.baseProps} />
                        </div>
                    </React.Fragment>
                )}
            </ToolkitProvider>
        </Container>
    )
}
